// 公開マップに表示するマーカーを作成する。

/*-------------------
    モジュールのimport
---------------------*/
import React from 'react';
import { Marker, Polyline, Popup, Circle, Polygon } from 'react-leaflet';
import { icon, divIcon } from 'leaflet';
/*-------------------
    classのimport
---------------------*/
import * as commons from '../commons';

import { NGINX_RESIDENT_PATH } from '../constant/constant';
import dpRadioimg from '../images/icon/dp_radio.png';

// const moveDetail = (props, id, kind) => {
//   const { history, location } = props;
//   const { search = '', pathname = '' } = location;
//   const urlSearch = search;

//   // URLを取得。
//   const url = pathname;
//   // 乱数を取得する。
//   const num = url.lastIndexOf('/');
//   const lgCrypt = url.slice(num + 1);

//   const tmpSearch = `${urlSearch}&id=${id}&kind=${kind}`;
//   history.push({ pathname: `../detail/${lgCrypt}`, search: tmpSearch });
// };

// GoogleMapを開く処理
const routeDisp = async (googleMapPath, point) => {
  const path = googleMapPath.replace('lat', point[1]).replace('lng', point[0]);
  window.open(path);
};

// 共通のボタン
const btnMap = (googleMapPath, point) => (
  <button
    type="button"
    onClick={() => {
      routeDisp(googleMapPath, point);
    }}
    className="detailBtn"
  >
    GoogleMapを表示
  </button>
);

// 共通のボタン
const btnRoute = (point, openRoute) => (
  <button
    type="button"
    onClick={() => {
      openRoute(point);
    }}
    className="detailBtn"
  >
    ルート案内
  </button>
);

// 地図画面でモーダルを開く
const createModal = (imgSrc, modalMhd) => {
  const imgModal = (
    <div className="modalBack" id="img-modal">
      <div style={{ textAlign: 'right' }}>
        <button type="button" onClick={() => modalMhd([])}>
          閉じる
        </button>
        <div className="modalMain">
          <img src={imgSrc} alt="" border="0" />
        </div>
      </div>
    </div>
  );

  modalMhd(imgModal);
};

// 凡例の非表示リストを整形する。
const changeHiddenList = (keyName, hiddenList) => {
  const tmpHiddenList = [];
  for (let i = 0; i < hiddenList.length; i += 1) {
    const [key, value] = hiddenList[i].split('_S_');
    if (key === keyName) tmpHiddenList.push(value);
  }
  return tmpHiddenList;
};

// 凡例の非表示リストを整形する。
const createUrl = (urlList) => {
  if (urlList.length === 0) return [];

  const content = [];
  for (let i = 0; i < urlList.length; i += 1) {
    const [url = '', title = ''] = urlList[i].split('||');
    content.push(
      <div className="popSub textRange" key={`url_${i}`}>
        <a href={url} target="_blank" rel="noreferrer noopener" className="">
          ・{title === '' ? url : title}
        </a>
      </div>
    );
  }
  return <div>参照URL{content}</div>;
};

// 避難所のマーカー作成
export const havenMarker = (useData, haven, hiddenList, commonProp) => {
  const { onClickGuide, openRoute, googleMapPath } = commonProp;
  const { haven_class: havenClassMasta = [], disaster: disasterMasta = [] } = haven;

  const markerList = [];
  const guideList = [];
  const checkList = [];
  for (let i = 0; i < useData.length; i += 1) {
    const { station = '', point = [], current = '' } = useData[i];
    const {
      name = '',
      address = '',
      open_flag: openFlag = '0',
      haven_class: havenClass = [],
      haven_sub_class: havenSubClass = [],
      facility_type: facilityType = [],
      tel_no: telNo = [],
      eva_level: evaLvl = [],
      elevation = '',
      limit_border: limitBorder = [],
      disaster = '',
      capacity = '',
      eq_resist: eqResist = false,
      stockpile = '',
      specified_place: specifiedPlace = '',
      acceptees = '',
      url_list: urlList = [],
    } = station;
    const { man = '', woman = '', support = '', household = '' } = current;
    const position = [point[1], point[0]];

    // 避難所副区分の名称を取得する。
    const subClassName = [];
    for (let j = 0; j < havenClassMasta.length; j += 1) {
      const { value = '', label = '' } = havenClassMasta[j];
      if (havenSubClass.indexOf(value) !== -1) subClassName.push(label);
    }

    // 災害種別の名称を取得する。
    const disasterName = [];
    for (let j = 0; j < disasterMasta.length; j += 1) {
      const { value = '', label = '' } = disasterMasta[j];
      if (disaster.indexOf(value) !== -1) {
        disasterName.push(<div className="popSub" key={commons.randomNum()}>{`${label}：〇`}</div>);
      }
    }

    // 人数を計算する。
    const culcMan = man === '' ? 0 : man;
    const culcWoman = woman === '' ? 0 : woman;
    // const culcSupport = support === '' ? 0 : support;
    // const currentPeople = culcMan + culcWoman + culcSupport;
    const currentPeople = culcMan + culcWoman;
    const emptyCurrent = man === '' && woman === '' && support === '';
    const resCulc = commons.culcCapacity(capacity, limitBorder, currentPeople, emptyCurrent);
    const { rate = '', level = '' } = resCulc;

    // 使用する画像を取得する。
    const havenClassItem = havenClassMasta.find((item) => item.value === havenClass) || '';
    const { img: havenImg = '', label: havenKind = '' } = havenClassItem;

    // 表示する種別かを判定
    const tmpHiddenList = changeHiddenList('haven', hiddenList);
    const disp = tmpHiddenList.indexOf(havenKind) === -1;

    // 凡例作成
    if (checkList.indexOf(havenKind) === -1) {
      const useImg = (
        <img src={`${NGINX_RESIDENT_PATH}/com/${havenImg.replace('arg', '1')}`} alt="" />
      );

      const dispIcon = (
        <button
          key={`haven_guide_${i}`}
          type="button"
          onClick={() => onClickGuide('haven', havenKind)}
        >
          {useImg}
          {disp ? <i>{havenKind}</i> : <i className="disabled">{havenKind}</i>}
        </button>
      );
      guideList.push(dispIcon);
      checkList.push(havenKind);
    }
    // 凡例作成終了

    // 非表示の場合はcontinue
    if (disp === false) continue;

    let argValue = '1';
    if (openFlag === '0') argValue = '0';
    else if (openFlag === 'n') argValue = 'n';
    else if (level === '2') argValue = '2';
    else if (level === '3') argValue = '3';
    else if (level === '4') argValue = '4';
    const useImg = havenImg.replace('arg', argValue);
    const markerIcon = icon({
      iconUrl: `${NGINX_RESIDENT_PATH}/com/${useImg}`,
      iconSize: [30, 30],
      //   iconSize: [2 * mapZoom, 2 * mapZoom],
    });

    // 現在の状態を作成する。
    const openStat = {};
    if (openFlag === '1') {
      openStat.color = '#1f8d46';
      openStat.stat = '開設';
    } else if (openFlag === '0') {
      openStat.color = '#7e7e7e';
      openStat.stat = '閉設';
    } else {
      openStat.color = '';
      openStat.stat = '使用不可';
    }
    const { color, stat } = openStat;

    const popBtn = (
      <Popup>
        <div className="markerPop">
          {/* TODO:以下は職員URLのみ出すかを検討する。 */}
          <div className="bold">現在の状況</div>
          <div>
            状態：<span style={{ color }}>●</span> {stat}
          </div>
          {capacity === '' ? null : <div>{`最大収容人数：${capacity}人`}</div>}
          {household === '' ? null : <div>{`世帯数：${household}`}</div>}
          {emptyCurrent === true ? null : (
            <div>
              {`収容人数：${currentPeople}人`}
              {rate === '' ? null : ` (収容率：${rate}%)`}
            </div>
          )}

          {emptyCurrent === true ? null : (
            <div>{`人数比：男性：${man === '' ? '-' : `${man}人`} , 女性：${
              woman === '' ? '-' : `${woman}人`
            } (要支援者：${support === '' ? '-' : `${support}人`})`}</div>
          )}
          <div className="mt10">{`【${havenKind}】`}</div>
          <div className="bold">{`名称：${name}`}</div>
          <div>{`住所：${address}`}</div>
          {subClassName.length === 0 ? null : <div>{`避難所副区分：${subClassName}`}</div>}
          {facilityType === '' ? null : <div>{`施設種別：${facilityType}`}</div>}
          {telNo === '' ? null : <div>{`電話番号：${telNo}`}</div>}
          {elevation === '' ? null : <div>{`標高：${elevation}m`}</div>}
          {disasterName.length === 0 ? null : <div>対応災害{disasterName}</div>}
          {evaLvl[0] === '' && evaLvl[1] === '' ? null : (
            <div>
              緊急避難レベル
              {evaLvl[0] === '' ? null : (
                <div className="popSub">{`風水害：レベル${evaLvl[0]}`}</div>
              )}
              {evaLvl[1] === '' ? null : (
                <div className="popSub">&emsp;{`津波：レベル${evaLvl[1]}`}</div>
              )}
            </div>
          )}
          {eqResist === true ? <div>耐震性：あり</div> : null}
          {stockpile === '' ? null : <div>{`備蓄品：${stockpile}`}</div>}
          {specifiedPlace === '' ? null : <div>{`指定場所：${specifiedPlace}`}</div>}
          {acceptees === '' ? null : <div>{`受入対象者：${acceptees}`}</div>}
          {createUrl(urlList)}
          {/* 経路表示ボタン */}
          {btnMap(googleMapPath, point)}
          {btnRoute(point, openRoute)}
          {/* 以下、職員時の遷移ボタン */}
          {/* {prmsn === 7 ? btnDetail(props, mastaId, 'haven') : null} */}
        </div>
      </Popup>
    );

    markerList.push(
      <Marker
        key={commons.randomNum()}
        position={position}
        icon={markerIcon}
        zIndexOffset={rate === '' ? 0 : parseInt(rate, 10)}
      >
        {popBtn}
      </Marker>
    );
  }

  const tmpGuide =
    guideList.length === 0 ? null : (
      <div className="fcmly_guide" key="haven_guide">
        <div className="guide_title">避難所</div>
        {/* {guideList} */}
        <div className="fcmly_guide_col">{guideList}</div>
      </div>
    );

  return { havenMarker: markerList, havenGuide: tmpGuide };
};

// 投稿データのマーカー作成
export const postMarker = (useData, hiddenList, commonProp) => {
  const { onClickGuide, openRoute, googleMapPath, onClickImg, prmsn } = commonProp;

  const markerList = [];
  const guideList = [];
  const checkList = [];
  for (let i = 0; i < useData.length; i += 1) {
    const { point, station = '', lcl_gov: lclGov = '', file_info: fileinfo = '' } = useData[i];

    const { lg_cd: lgCd = '' } = lclGov;
    const {
      title = '',
      main,
      occurred_at: occurredAt = '',
      color = '',
      back_color: backColor = '',
      marker_img: markerImg = '',
      kind_name: kindName = '',
      disp_flag: dispFlag = '1',
      url_list: urlList = [],
    } = station;
    const position = [point[1], point[0]];

    const tmpDispFlag = prmsn === 7 ? dispFlag : '4';

    // テキストのアイコン
    const textIcon = divIcon({
      html: `<div style="color:${color}; background:rgba(${backColor})" class="crossIcon status-marker">!${commons.postStatus(
        tmpDispFlag
      )}</div>`,
      iconSize: [30, 30],
      //   iconSize: [2 * mapZoom, 2 * mapZoom],
      className: '',
    });

    // 画像のアイコン
    const imgIcon = divIcon({
      html: `<img src="${NGINX_RESIDENT_PATH}/com/${markerImg}" class="status-marker">${commons.postStatus(
        tmpDispFlag
      )}</img>`,
      iconSize: [30, 30],
      className: '',
    });

    const markerIcon = markerImg === '' ? textIcon : imgIcon;

    // 凡例作成用
    const checkStr = markerImg === '' ? `${color}${backColor}` : markerImg;

    // 表示する種別かを判定
    const tmpHiddenList = changeHiddenList('post', hiddenList);
    const disp = tmpHiddenList.indexOf(checkStr) === -1;

    if (checkList.indexOf(checkStr) === -1) {
      checkList.push(checkStr);

      guideList.push(
        <button
          key={`post_guide_${i}`}
          type="button"
          onClick={() => onClickGuide('post', checkStr)}
        >
          {markerImg === '' ? (
            <span style={{ color, background: `rgba(${backColor})` }} className="crossIcon">
              !
            </span>
          ) : (
            <img src={`${NGINX_RESIDENT_PATH}/com/${markerImg}`} alt="" />
          )}
          {disp ? <i>{kindName}</i> : <i className="disabled">{kindName}</i>}
        </button>
      );
    }
    // 凡例作成終了

    // 非表示の場合はcontinue
    if (disp === false) continue;

    // 画像リストを作成
    const imgList = [];
    for (let j = 0; j < fileinfo.length; j += 1) {
      const { name = '', public: tmpPublic = false, enable: tmpEnable = true } = fileinfo[j];

      if (tmpPublic === false || tmpEnable === false) continue;

      imgList.push(
        <button
          type="button"
          key={`img_post_${j}`}
          onClick={() => createModal(`${NGINX_RESIDENT_PATH}/${lgCd}/${name}`, onClickImg)}
        >
          <img
            src={`${NGINX_RESIDENT_PATH}/${lgCd}/${name}`}
            width="100"
            height="100"
            alt=""
            border="0"
            className="mr10 mt10"
          />
        </button>
      );
    }

    const { color: dispColor = '', name: dispName = '' } = commons.postStatus(tmpDispFlag, false);

    const popBtn = (
      <Popup>
        <div className="markerPop">
          {dispName === '' ? null : (
            <div>
              <span className="pb-badge" style={{ backgroundColor: dispColor }}>
                {dispName}
              </span>
            </div>
          )}
          <div>{`【${kindName}】`}</div>
          <div>{`受信日時：${commons.changeJapanDate(occurredAt)}`}</div>
          <div className="bold">{`タイトル：${title}`}</div>
          {main === '' ? null : <div className="popMain">本文{commons.shapedContents(main)}</div>}
          {imgList}
          {createUrl(urlList)}
          {btnMap(googleMapPath, point)}
          {btnRoute(point, openRoute)}
        </div>
      </Popup>
    );

    markerList.push(
      <Marker key={commons.randomNum()} position={position} icon={markerIcon}>
        {popBtn}
      </Marker>
    );
  }

  const tmpGuide =
    guideList.length === 0 ? null : (
      <div className="fcmly_guide" key="post_guide">
        <div className="guide_title">投稿データ</div>
        {/* {guideList} */}
        <div className="fcmly_guide_col">{guideList}</div>
      </div>
    );

  return { postMarker: markerList, postGuide: tmpGuide };
};

// 道路規制のマーカー作成
export const roadMarker = (useData, tmpList, hiddenList, commonProp) => {
  const { onClickGuide } = commonProp;

  const markerList = [];
  const lineList = [];
  const guideList = [];
  const checkList = [];
  for (let i = 0; i < useData.length; i += 1) {
    const { station = '' } = useData[i];

    const {
      kind = '',
      title = '',
      main = '',
      start_time: startTime = '',
      end_time: endTime = '',
      other = '',
      inquiry = '',
      area = '',
      url_list: urlList = [],
    } = station;

    const foundObject = tmpList.find((item) => item.value === kind);
    const { image = '', color = '', dash = '', label = '' } = foundObject;

    // 表示する種別かを判定
    const tmpHiddenList = changeHiddenList('road', hiddenList);
    const disp = tmpHiddenList.indexOf(label) === -1;

    // 凡例を作成する。
    if (checkList.indexOf(label) === -1) {
      const useImg = <img src={`${NGINX_RESIDENT_PATH}/com/${image}`} alt="" />;

      guideList.push(
        <button key={`road_guide_${i}`} type="button" onClick={() => onClickGuide('road', label)}>
          {image === '' ? <div style={{ width: '30px', display: 'inline-block' }} /> : useImg}
          <span style={{ color, marginRight: '5px' }}>{dash === '' ? '━' : '--'}</span>
          {disp ? <i>{label}</i> : <i className="disabled">{label}</i>}
        </button>
      );
      checkList.push(label);
    }
    // 凡例作成終了

    // 非表示の場合はcontinue
    if (disp === false) continue;

    const popBtn = (
      <Popup>
        <div className="markerPop">
          <div>{`【${label}】`}</div>
          <div className="bold">{`名称：${title}`}</div>
          {main === '' ? null : <div className="popMain">本文{commons.shapedContents(main)}</div>}
          {startTime === '' ? null : <div>{`開始時間：${commons.changeJapanDate(startTime)}`}</div>}
          {endTime === '' ? null : <div>{`終了時間：${commons.changeJapanDate(endTime)}`}</div>}
          {endTime === '' ? null : <div>{`その他：${other}`}</div>}
          {endTime === '' ? null : <div>{`問い合わせ先：${inquiry}`}</div>}
          {createUrl(urlList)}
        </div>
      </Popup>
    );

    // 通行止めの線を引く。
    lineList.push(
      <Polyline
        positions={area}
        color={color} // 線の色
        weight={5} // 線の太さ
        dashArray={dash}
        key={commons.randomNum()}
      />
    );

    if (image === '') continue;

    const markerIcon = icon({
      iconUrl: `${NGINX_RESIDENT_PATH}/com/${image}`,
      iconSize: [30, 30],
      //   iconSize: [2 * mapZoom, 2 * mapZoom],
    });

    for (let j = 0; j < 2; j += 1) {
      const position = j === 0 ? area[0] : area[area.length - 1];
      markerList.push(
        <Marker key={commons.randomNum()} position={position} icon={markerIcon}>
          {popBtn}
        </Marker>
      );
    }
  }

  const sumMarker = [...markerList, ...lineList];
  const tmpGuide =
    guideList.length === 0 ? null : (
      <div className="fcmly_guide" key="road_guide">
        <div className="guide_title">道路規制</div>
        <div className="fcmly_guide_col">{guideList}</div>
        {/* {guideList} */}
      </div>
    );

  return { roadMarker: sumMarker, roadGuide: tmpGuide };
};

// 屋外子局のマーカー作成
export const radioMarker = (useData) => {
  const markerList = [];
  for (let i = 0; i < useData.length; i += 1) {
    const { station = '' } = useData[i];
    const { name = '', point = [] } = station;
    const position = [point[1], point[0]];

    const markerIcon = icon({
      iconUrl: dpRadioimg,
      iconSize: [30, 30],
      //   iconSize: [2 * mapZoom, 2 * mapZoom],
    });

    const popBtn = (
      <Popup>
        <div className="markerPop">
          <div className="bold">{`名称：${name}`}</div>
        </div>
      </Popup>
    );

    markerList.push(
      <Marker key={commons.randomNum()} position={position} icon={markerIcon}>
        {popBtn}
      </Marker>
    );
  }

  return markerList;
};

// 汎用マーカー作成
export const stdMarker = (useData, standard, hiddenList, commonProp) => {
  const { onClickGuide, openRoute, googleMapPath, onClickImg } = commonProp;

  const markerList = [];
  const guideList = [];
  const checkList = [];
  const { color: colorMasta = [] } = standard;
  for (let i = 0; i < useData.length; i += 1) {
    const { station = '', point = [] } = useData[i];

    const {
      name = '',
      kind_name: kindName = '',
      color_kind: colorKind = '',
      other_color: otherColor = '',
      url_list: urlList = [],
      img_url_list: imgUrlList = [],
    } = station;

    const position = [point[1], point[0]];

    let color = '';
    if (colorKind === '-1') color = otherColor;
    else {
      for (let j = 0; j < colorMasta.length; j += 1) {
        const { value, color: tmpColor } = colorMasta[j];
        if (value === colorKind) {
          color = tmpColor;
          break;
        }
      }
    }

    const borderColor =
      commons.backColorCheck(color, true) === '#000000' ? 'standardB' : 'standardW';

    const tmpStyle = { backgroundColor: color, width: '20px', height: '20px' };

    // 凡例作成用
    const checkStr = `${color}_${kindName}`;

    // 表示する種別かを判定
    const tmpHiddenList = changeHiddenList('std', hiddenList);
    const disp = tmpHiddenList.indexOf(checkStr) === -1;

    if (checkList.indexOf(checkStr) === -1 && kindName !== '') {
      checkList.push(checkStr);
      guideList.push(
        <button
          key={`st_guide_${i}`}
          type="button"
          className="icon-with-text"
          onClick={() => onClickGuide('std', checkStr)}
        >
          {/* <div key={`st_guide_${i}`}  className="icon-with-text"> */}
          <div style={tmpStyle} className="standardIcon">
            <div className={`standardCross ${borderColor}`} />
          </div>
          {disp ? <i>{kindName}</i> : <i className="disabled">{kindName}</i>}
        </button>
      );
    }
    // 凡例作成終了

    // 非表示の場合はcontinue
    if (disp === false) continue;

    const markerIcon = divIcon({
      html: `<div style="background-color:${color};" class="standardIcon"><div class="standardCross ${borderColor}"></div>`,
      iconSize: [30, 30],
      // iconAnchor: [1 * nowZoom, 1 * nowZoom],
      className: '',
    });

    const imgList = [];
    for (let j = 0; j < imgUrlList.length; j += 1) {
      const [src = '', title = ''] = imgUrlList[j].split('||');
      // imgTable.push(
      //   <React.Fragment key={`img_std_${j}`}>
      //     <div>{title}</div>
      //     <img src={src} width="150" height="150" alt="" border="0" loading="lazy" />
      //   </React.Fragment>
      // );
      imgList.push(
        <button type="button" key={`img_std_${j}`} onClick={() => createModal(src, onClickImg)}>
          {title}
          <img src={src} width="150" height="150" alt="" border="0" loading="lazy" />
        </button>
      );
    }

    const popBtn = (
      <Popup>
        <div className="markerPop">
          <div className="bold">{`名称：${name}`}</div>
          <div>{`種別：${kindName}`}</div>
          {imgList}
          {createUrl(urlList)}
          <div>
            {btnMap(googleMapPath, point)}
            {btnRoute(point, openRoute)}
          </div>
        </div>
      </Popup>
    );

    markerList.push(
      <Marker key={commons.randomNum()} position={position} icon={markerIcon}>
        {popBtn}
      </Marker>
    );
  }

  const tmpGuide =
    guideList.length === 0 ? null : (
      <div className="fcmly_guide" key="st_guide">
        <div className="guide_title">汎用マーカー</div>
        {/* {guideList} */}
        <div className="fcmly_guide_col">{guideList}</div>
      </div>
    );

  return { stdMarker: markerList, stdGuide: tmpGuide };
};

// エリア指定のマーカー作成
export const areaMarker = (useData, hiddenList, commonProp) => {
  const { onClickGuide } = commonProp;

  const markerList = [];
  const guideList = [];
  for (let i = 0; i < useData.length; i += 1) {
    const { station = '', area_list: areaList = [] } = useData[i];
    const {
      name: stationName = '',
      line_width: lineWidth = '3',
      line_color: lineColor = '#000000',
      line_opacity: lineOpacity = '1',
      line_kind: tmpKind = '0',
      face_color: faceColor = '#000000',
      face_opacity: faceOpacity = '0.3',
      free_text: freeText = '',
      url_list: urlList = [],
    } = station;

    let dashArray = '';
    if (tmpKind === '1') {
      dashArray = '20,10,5,10';
    } else if (tmpKind === '2') {
      dashArray = '16,16';
    }

    // 作成するエリアのCSS要素を作成する。
    const styleOption = {
      weight: lineWidth,
      color: lineColor,
      opacity: lineOpacity,
      fillColor: faceColor,
      fillOpacity: faceOpacity,
      dashArray,
    };

    // エリアの疑似データ
    let borderKind = 'solid';
    if (tmpKind === '1') borderKind = 'dashed';
    else if (tmpKind === '2') borderKind = 'dotted';

    const rectangleStyle = {
      width: '30px' /* 幅 */,
      height: '20px' /* 高さ */,
      backgroundColor: `rgba(${commons.hexToRgb(faceColor, faceOpacity)})`,
      border: `3px ${borderKind} rgba(${commons.hexToRgb(lineColor, lineOpacity)})`,
    };

    // 表示する種別かを判定
    const tmpHiddenList = changeHiddenList('area', hiddenList);
    const disp = tmpHiddenList.indexOf(stationName) === -1;

    // 凡例要素作成
    guideList.push(
      <button
        key={`area_guide_${i}`}
        type="button"
        onClick={() => onClickGuide('area', stationName)}
        className="icon-with-text"
      >
        <div style={rectangleStyle} />
        {disp ? <i>{stationName}</i> : <i className="disabled">{stationName}</i>}
      </button>
    );

    // 非表示の場合はcontinue
    if (disp === false) continue;

    for (let j = 0; j < areaList.length; j += 1) {
      const { center, radius, point_list: pointList, kind } = areaList[j];

      const popBtn = (
        <Popup>
          <div className="markerPop">
            <div style={{ fontWeight: 'bold' }}>{stationName}</div>
            {freeText === '' ? null : (
              <div className="popMain">{commons.shapedContents(freeText)}</div>
            )}
            {createUrl(urlList)}
          </div>
        </Popup>
      );

      if (kind === '0') {
        // 円の場合
        markerList.push(
          <Circle
            center={center}
            radius={radius}
            pathOptions={styleOption}
            key={commons.randomNum()}
          >
            {popBtn}
          </Circle>
        );
      } else if (kind === '1') {
        // 多角形の場合
        markerList.push(
          <Polygon positions={pointList} pathOptions={styleOption} key={commons.randomNum()}>
            {popBtn}
          </Polygon>
        );
      }
    }
  }

  const tmpGuide =
    guideList.length === 0 ? null : (
      <div className="fcmly_guide" key="area_guide">
        <div className="guide_title">作図エリア</div>
        {/* {guideList} */}
        <div className="fcmly_guide_col">{guideList}</div>
      </div>
    );

  return { areaMarker: markerList, areaGuide: tmpGuide };
};
